module.exports = __webpack_public_path__ + "static/img/icon-check-no.834adafb.png";